import { basePathIcons, SvgIcon } from '@y42/core/icon';

const iconsBasePath = `${basePathIcons}/general`;

export const removedIcon: SvgIcon = `${iconsBasePath}/removed.svg`;
export const importIcon: SvgIcon = `${iconsBasePath}/job-icon.svg`;
export const warnMark: SvgIcon = `${iconsBasePath}/warn-mark.svg`;
export const y42FullLogo: SvgIcon = `${basePathIcons}/y42-logos/y42-full-logo.svg`;
